import React from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useVerifyIdentityStore, { fetchVerifyRequestData, verifyRequestStatusIndex } from '../../../App/Stores/VerifyIdentityStore';
import CommonButton from '../../../Components/Button/CommonButton';
import CommonModal from '../../../Components/Modal/CommonModal';

const RejectRequestModal = () => {

    const { showRejectRequestModal, setShowRejectRequestModal, verificationDetails,setVerifyIdentityStatus } = useVerifyIdentityStore()

    const { t } = useTranslation();

    const navigate = useNavigate()

    useEffect(() => {
        fetchDetailData()
    }, [])

    const fetchDetailData = async () => {
        await fetchVerifyRequestData()
    }

    return (
        <div>
            <CommonModal
                showModal={showRejectRequestModal}
                setShowModal={setShowRejectRequestModal}
                modalTitle={t("Confirmation")}
                mainContent={
                    <>
                        <div className="pt-5 pb-[30px] flex justify-center items-center">
                            <div>You are confirming that the information of the customer is not matching with the system. if you reject the verification request, the customer could send verification request again.</div>
                        </div>
                        <div className="flex justify-center">
                            <CommonButton
                                onClick={() => {
                                    let body = {}
                                    body = { "user_id": verificationDetails?.user_id, "status": "not_verified" }
                                    const successfulStatus = verifyRequestStatusIndex(body)
                                    if (successfulStatus) {

                                        setShowRejectRequestModal(false)
                                        navigate("/verify/identity")
                                        setVerifyIdentityStatus('history')
                                    }
                                }}
                                width="w-[180px]"
                                btnLabel="Reject Request"
                            />
                        </div>
                    </>
                }
            />
        </div>
    );
};

export default RejectRequestModal;